
export const clearSessionStorage = () => localStorage.clear()
export const clear = () => clearSessionStorage()
